import heroPerson from "@/assets/hero-person-male-friendly.png";

const KnowledgeBaseMoodVisual = () => {
  return (
    <div className="relative w-full h-full min-h-[400px] rounded-2xl overflow-hidden bg-secondary/40">
      {/* Person image - right aligned, full height */}
      <img
        src={heroPerson}
        alt="Lächelnde Person im Gespräch mit AI Agent"
        className="absolute right-0 top-0 h-full w-[65%] object-cover object-top"
      />

      {/* Soft gradient overlay for text readability */}
      <div className="absolute inset-0 bg-gradient-to-r from-secondary/95 via-secondary/60 to-transparent" />

      {/* Chat conversation bubbles */}
      <div className="relative z-10 flex flex-col gap-3 p-6 md:p-8 max-w-[280px]">
        {/* Bot question */}
        <div
          className="bg-background border border-border rounded-2xl rounded-tl-sm px-4 py-3 shadow-[0_4px_24px_rgba(0,196,180,0.08)] animate-fade-in"
          style={{ animationDelay: "0.1s" }}
        >
          <p className="text-sm text-primary font-medium leading-snug">
            Haben Sie Fragen zu unseren Antriebslösungen?
          </p>
        </div>

        {/* User reply */}
        <div
          className="self-end bg-accent text-accent-foreground rounded-2xl rounded-tr-sm px-4 py-3 shadow-md animate-fade-in"
          style={{ animationDelay: "0.4s" }}
        >
          <p className="text-sm font-medium leading-snug">
            Welcher Frequenzumrichter passt zu meiner Anlage?
          </p>
        </div>

        {/* Bot response */}
        <div
          className="bg-background border border-border rounded-2xl rounded-tl-sm px-4 py-3 shadow-[0_4px_24px_rgba(0,196,180,0.08)] animate-fade-in"
          style={{ animationDelay: "0.7s" }}
        >
          <p className="text-sm text-primary font-medium leading-snug">
            Basierend auf Ihren Spezifikationen empfehle ich die Serie FU-3200. Hier sind die technischen Daten. ⚙️
          </p>
        </div>

        {/* Quick reply options */}
        <div className="flex flex-wrap gap-2 animate-fade-in" style={{ animationDelay: "1s" }}>
          <span className="px-3 py-1.5 bg-background border border-border rounded-full text-xs font-medium text-primary shadow-sm">
            Datenblatt anfordern
          </span>
          <span className="px-3 py-1.5 bg-background border border-border rounded-full text-xs font-medium text-primary shadow-sm">
            Beratung buchen
          </span>
        </div>
      </div>
    </div>
  );
};

export default KnowledgeBaseMoodVisual;
